import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';

const Main = props => {
	const { selectOptions } = props.filtersFormData;
	return (
		<div className="payouts-form-wrap">
			<form className="ui-form payouts-form__main clearfix">
				<div className="payouts-form__main-fields">
					<div className="ui-form__element statuses">
						<Field
							name="statuses"
							placeholder={props.intl('Statuses')}
							component={SelectField}
							searchable={false}
							multi={true}
							showLabel={false}
							options={selectOptions['statuses']}
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

Main.propTypes = {
	filtersFormData: PropTypes.object,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	affiliatesLookups: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func
};

export default reduxForm({
	form: 'payoutsListForm'
})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/filters/main.js